module.exports = __webpack_public_path__ + "static/media/trying_to_connect.60eb9357.mp3";